import React from 'react';
import { CommonIconProps } from './Icon';

const Eye = ({
  color,
  isOpen,
}: CommonIconProps & { isOpen?: boolean }): JSX.Element => (
  <>
    <path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75734 14.9921C4.91366 14.1106 4.51134 13.1025 4.13927 12.0534L4.20805 11.88C4.62848 10.8187 5.00229 9.87509 5.83018 8.99703C6.74988 8.02158 8.4268 7 12 7C15.5732 7 17.2501 8.02158 18.1698 8.99703C18.9977 9.87509 19.3715 10.8187 19.7919 11.88L19.8607 12.0534C19.4887 13.1025 19.0863 14.1106 18.2427 14.9921C17.3015 15.9754 15.5775 17 12 17C8.42254 17 6.6985 15.9754 5.75734 14.9921ZM21.8633 12.3909C21.9104 12.2547 21.9557 12.1241 22 12C21.9062 11.7811 21.8124 11.5416 21.7128 11.2874L21.7127 11.2873C20.7507 8.83195 19.2493 5 12 5C4.75069 5 3.24931 8.83195 2.28729 11.2873C2.18767 11.5416 2.09384 11.781 2 12C2.04433 12.1241 2.08961 12.2549 2.1368 12.3911C2.9768 14.8166 4.42558 19 12 19C19.5744 19 21.0232 14.8166 21.8632 12.3911L21.8633 12.3909ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
    />

    {isOpen ? null : (
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z"
      />
    )}
  </>
);

const EyeOpenedIcon = (props: CommonIconProps): JSX.Element => (
  <Eye {...props} isOpen />
);

const EyeClosedIcon = (props: CommonIconProps): JSX.Element => (
  <Eye {...props} />
);

export { EyeOpenedIcon, EyeClosedIcon };
